// eslint-disable-next-line @altermaind/you-shall-not-pass
import { en as assessmentsLocales } from '@/assessments/locales';
import { en as billingLocales } from '@/billing/locales';
import { en as configurationLocales } from '@/configuration/locales';
import { en as conversationLocales } from '@/conversations/locales';
import { en as coreLocales } from '@/core/locales';
import { en as creditsLocales } from '@/credits/locales';
import { en as dashboardLocales } from '@/dashboard/locales';
import { en as departmentLocales } from '@/department/locales';
import { en as departmentsLocales } from '@/departments/locales';
import { en as invitationLocales } from '@/invitation/locales';
import { en as loginLocales } from '@/login/locales';
import { en as maintenanceModeLocales } from '@/maintenanceMode/locales';
import { UserStatus } from '@/organization/state/types';
import { en as paymentsLocales } from '@/payments/locales';
import { en as peopleLocales } from '@/people/locales';
import { en as profileLocales } from '@/profile/locales';
import { en as reportsLocales } from '@/reports/locales';
import { en as settingsLocales } from '@/settings/locales';
import { en as surveysLocales } from '@/surveys/locales';
import { AccountStatus } from '@/swagger/constants/anagraphics-enums';
import { EventType } from '@/swagger/constants/credits-enums';
import { en as aiPlaygroundLocales } from '@/training/aiPlayground/locales';
import { en as documentLocales } from '@/training/documents/locales';
import { en as trainingHardSkillsLocales } from '@/training/hardSkills/locales';
import { en as quizLocales } from '@/training/quiz/locales';
import { en as trainingSoftSkillsLocales } from '@/training/softSkills/locales';
import { en as videoLocales } from '@/training/video/locales';
import { EMAIL_SUPPORT, SuccessCodes } from '../constants';
import { PlatformType } from '../constants/platformType';

export const en = {
  general: {
    menu: 'MENU',
    logout: 'Logout',
    goToLogin: 'Go to login',
    confirm: 'Confirm',
    documentation: 'Documentation',
    organization: 'Organization',
    platform: 'Platform',
    language: 'Language',
    switchOrganization: {
      title: 'Organizations',
      nowLogged: 'In used',
      buttonGoBack: 'Back',
    },
    switchPlatform: {
      title: 'Which platform do you want to access?',
      [PlatformType.ADMIN]: 'Admin dashboard',
      [PlatformType.LEARNING]: 'Learning dashboard',
      nowLogged: 'In used',
      buttonGoBack: 'Back',
      viewProfile: 'View profile',
      creditLabel: 'credits',
      openCreditsModal: 'Go to !{CREDITS}!',
      openCreditsModalLabel: 'credits',
    },
  },
  dialogLogout: {
    title: 'Logout from Slash',
    description: 'You are about to log out from Slash.',
    confirmText: 'Do you confirm you want to proceed?',
    confirm: 'Logout',
    cancel: 'Cancel',
  },
  table: {
    noData: 'No data available',
    noContent: 'No content available',
    ofPages: 'of {{total}} pages',
    selectedCount: '{{count}} selected',
    deselectAll: 'Deselect all',
  },
  builtWith: 'Built with',
  errorBoundary: {
    title: {
      default: 'An error occurred.',
      USER_DISABLED: 'Warning',
      USER_PENDING: 'Warning',
      POPUP_BLOCKED: 'Warning, pop-ups blocked by the browser',
      LICENSE_NOT_FOUND: 'Warning, it seems you do not have an active plan',
    },
    description: {
      default: 'Try going back to the homepage and starting over.',
      CRITICAL: 'A critical error occurred. Please try again later.',
      USER_DISABLED:
        'You are not authorized to use the application. Contact your organization admin.',
      USER_PENDING: 'Your registration is pending. Check your email to complete the registration.',
      POPUP_BLOCKED: 'Make sure your browser is not blocking pop-ups.',
      LICENSE_NOT_FOUND:
        'Contact altermAInd to activate your plan. \nIf you already have an active plan, contact customer support.',
    },
    back: 'Back to Home',
    switchOrganization: 'Do you want to switch organization?',
    dialogSwitchOrganization: {
      title: 'Switch organization',
      description: 'Select an organization you have access to',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
  },
  successBoundary: {
    title: {
      default: 'Congratulations!',
      [SuccessCodes.REGISTRATION_COMPLETED]: 'Registration completed',
      [SuccessCodes.PASSWORD_RESET_COMPLETED]: 'Password reset completed',
    },
    description: {
      default: 'Congratulations. Go back to the login page.',
      [SuccessCodes.REGISTRATION_COMPLETED]:
        'Congratulations. Registration successful, you can now log in.',
      [SuccessCodes.PASSWORD_RESET_COMPLETED]:
        'Congratulations. You have successfully reset your password, you can now log in.',
    },
    back: 'Go to login',
  },
  menu: {
    homepage: 'Homepage',
    myAssessments: 'My Assessments',
    companyStructure: 'Company',
    departments: 'Departments',
    people: 'Records',
    survey: 'Assessment',
    settings: 'Settings',
    training: 'Training',
    aiPlayground: 'AI Playground',
    trainingSoftSkills: 'Training Soft skills',
    trainingHardSkills: 'Training Hard skills',
    department: 'My department',
    team: 'My team',
    comingSoon: 'Soon',
    hardSkills: 'Hard Skills',
    reports: 'Reports',
    assessmentsReports: 'Assessment Results',
    trainingReports: 'Training Usage',
    chatBot: 'AI Assistant',
  },
  languageSelector: {
    title: 'Language',
  },
  goBack: {
    title: 'Back',
  },
  goToPublicsDocs: {
    label: 'Go to guide',
  },
  tableHeader: {
    filter: 'Filter',
    search: 'Search...',
    add: '+',
  },
  thankYouMessage: {
    success: {
      title: 'Request sent successfully!',
      text: 'We have received your plan change request.\nA summary of the contact request will be sent shortly to the provided email address.',
      cta: 'Close',
    },
    error: {
      title: 'Oops, something went wrong',
      text: 'We were unable to send your request.\nPlease check the entered data and try again. If the problem persists, wait a few minutes and try again later.',
      cta: 'Retry',
    },
  },
  headerTable: {
    new: 'New',
    filter: 'Filter',
    search: 'Search...',
  },
  ctaContainer: {
    edit: 'Edit',
    remove: 'Remove',
    new: 'New',
    close: 'Close',
    viewDetail: 'View details',
    refresh: 'Refresh data',
    filter: 'Filter',
  },
  wizard: {
    nextButton: 'Next',
    previousButton: 'Back',
    skipButton: 'Skip this step',
  },
  success: {
    genericApiSuccess: 'Operation completed successfully',
    copyToClipboard: 'Copied to clipboard',
  },
  warning: {
    fileTooLarge: 'The selected file is too large. The maximum size is {{maxSize}}',
  },
  errors: {
    genericApiError: 'An error occurred, please try again later',
  },
  inputs: {
    placeholderSearch: 'Search...',
    loadMore: 'Load more...',
    fileInput: {
      placeholder: 'Click here or drag to add the file',
      maxFileSizeDescription: 'Maximum {{size}} supported.',
      supportFilesDescription: 'Supported formats: {{formats}}',
      errors: {
        maxFileSize:
          'Unable to upload the file. Ensure the file size is below the maximum allowed limit and try again.',
        typeNotAllowed: 'Unable to upload the file. Ensure the file is supported and try again.',
      },
    },
    requiredError: 'This field is required',
  },
  notificabionHub: {
    title: 'Notifications',
    noNotification: 'No notification available.',
    integrationNotReliable:
      'The SLA calculation for the integration "{{integrationName}}" is not reliable. The calculation will become reliable after 30 days of continuous monitoring.',
  },
  sla: {
    notReliable:
      'The SLA calculation for some integrations is not yet reliable, click here for more details.',
  },
  userStatus: {
    [UserStatus.Enabled]: 'Active',
    [UserStatus.Pending]: 'Invited',
    [UserStatus.Disabled]: 'Disabled',
  },
  charts: {
    stacked: {
      beginning: 'Beginning:',
      intermediate: 'Intermediate:',
      advanced: 'Advanced:',
      totalCompleted: 'Total people: {{total}}',
      totalPeople: '{{total}} people',
    },
  },
  tutorial: {
    title: 'Welcome to Slash',
    slides: {
      slide1: {
        title: 'Manage your organization’s records by importing employee data',
        description:
          'In the Records section, you can create profiles for your organization’s employees: this is the essential first step to start using Slash, sending assessments, and discovering the soft skills of the people working with you.',
      },
      slide2: {
        title: 'Customize your Slash',
        description:
          'In the Settings section, you can customize the look & feel of your Slash, creating an environment that best reflects your organization and brand.',
      },
      slide3: {
        title: 'Send assessments to your organization’s employees',
        description:
          'To start the profiling process and suggest the most suitable training for each employee, send the assessment to all team members. You can find the assessment in the Assessment section.',
      },
      slide4: {
        title: 'Ask your AI assistant',
        description: 'Your AI assistant is available to answer your questions about the platform.',
      },
    },
    goToGuideCta: 'usage guide',
    goToGuide: 'Visit the {{goToGuideCta}} for more information',
  },
  slider: {
    previous: 'Back',
    next: 'Next',
    close: 'Close',
  },
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  credits: {
    [EventType.SURVEY]: 'Survey',
    [EventType.MEDIA]: 'Media',
    [EventType.RECHARGE]: 'Recharge',
    [EventType.EXPIRATION]: 'Expiration',
    [EventType.REWARD]: 'Reward',
  },
  profileCard: {
    contentProfile: {
      profile: {
        fiscalCode: 'Tax Code',
        birthDate: 'Date of Birth',
        email: 'Email',
        jobLevel: 'Job Level',
        role: 'Company Role',
        department: 'Department',
        area: 'Team',
        manager: 'Manager',
        emailManager: 'Manager Email',
        statusTooltip:
          'The status indicates whether the profile is active, pending, disabled, or not yet invited.',
        status: {
          label: 'Status',
          [AccountStatus.ENABLED]: 'Active',
          [AccountStatus.DISABLED]: 'Disabled',
          [AccountStatus.PENDING]: 'Pending',
          [AccountStatus.NOT_INVITED]: 'Not active',
        },
      },
    },
    alerts: {
      managerWrong:
        'This profile is not associated with a registered manager. \nSolutions: edit the email, remove the manager, or create the manager’s profile.',
      hasIssue:
        '{{count}} issue has been detected in the profile. Edit to fix it and ensure all information is up to date.',
      hasIssues:
        '{{count}} issues have been detected in the profile. Edit to fix them and ensure all information is up to date.',
      alertData: 'If you notice incorrect data, please contact the HR team to update it.',
    },
    dialogs: {
      disableProfile: {
        title: 'Deactivate Profile',
        description:
          'Deactivating the profile cancels the user’s learning license and consequently blocks their access to the platform.\nYou can reactivate the profile at any time from this section.',
        confirmation: 'Do you confirm you want to proceed?',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Deactivate',
        },
      },
      enableProfile: {
        title: 'Activate Profile',
        description:
          'Activating the profile assigns a learning license to the user and consequently unlocks their access to the platform.',
        confirmation: 'Do you confirm you want to proceed?',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Activate',
        },
      },
      deleteProfile: {
        title: 'Remove profile',
        description:
          'You are removing a profile. Removing the profile cancels the user’s learning license and consequently blocks their access to the platform.',
        confirmation: 'Are you sure you want to proceed?',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Remove',
        },
        warnings: {
          departmentLosesManager:
            'The selected profile is the manager of a department. The department "{{departmentName}}" will be left without a manager.',
          departmentBecomesEmpty:
            'The department "{{departmentName}}" will have no members left and will be automatically deleted.',
        },
      },
    },
    editProfile: {
      errors: {
        emailAlreadyInUse: 'The entered email is already in use within this organization.',
        managerError:
          'Unrecognized manager email: no profile exists with this email. Correct the email, remove the manager, or create the manager’s profile first.',
      },
      title: 'Edit Profile',
      details: 'Profile Details',
      roleInfo: 'Role information',
      anagraphicDetails: 'Profile details',
      cta: {
        edit: 'Edit Profile',
        disabled: 'Deactivate Profile',
        enable: 'Activate Profile',
        remove: 'Remove Profile',
      },
      fields: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        emailTooltip: `The email cannot be changed if the user is already active. To change it, contact us at ${EMAIL_SUPPORT}`,
        role: 'Company Role',
        department: 'Department',
        fiscalCode: 'Tax Code',
        area: 'Team',
        emailManager: 'Manager Email',
        manager: 'Manager Email',
        jobLevel: 'Job Level',
        birthDate: 'Date of Birth',
        birthDatePlaceholder: 'DD/MM/YYYY',
        createDepartment: '+ Create department',
        chooseDepartment: 'Choose department',
        departmentPlaceholder: 'Select department',
        createTeam: '+ Create team',
        chooseTeam: 'Choose team',
        teamPlaceholder: 'Select team',
      },
      alerts: {
        emailManagerInfo:
          'The manager is optional. You can leave the field empty or the email if already registered.',
        emailManagerWrong:
          'Unrecognized email: no profile exists with this email. \nCorrect the email, remove the manager, or create the manager’s profile first.',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
      },
      dialogs: {
        disableProfile: {
          title: 'Deactivate Profile',
          description:
            'Deactivating the profile cancels the user’s learning license and consequently blocks their access to the platform.\nYou can reactivate the profile at any time from this section.',
          confirmation: 'Do you confirm you want to proceed?',
          buttons: {
            cancel: 'Cancel',
            confirm: 'Deactivate',
          },
        },
        enableProfile: {
          title: 'Activate Profile',
          description:
            'Activating the profile assigns a learning license to the user and consequently unlocks their access to the platform.',
          confirmation: 'Do you confirm you want to proceed?',
          buttons: {
            cancel: 'Cancel',
            confirm: 'Activate',
          },
        },
      },
    },
  },
  surveysShared: {
    recapAssessment: {
      overview: {
        completed: 'Completed surveys',
        invited: 'Invited surveys',
        toComplete: 'Surveys to complete',
        completionRate: 'Completion rate',
        linkAssessment: 'Go to Assessment',
        info: 'No results are available yet: the dashboard will be visible once at least one response has been collected.',
        infoWithName:
          'No results are available yet for {{templateName}}: the dashboard will be visible once at least one response has been collected.',
      },
    },
  },
  sharedComponents: {
    readMoreTypography: {
      readMoreLabel: 'Read more',
      readLessLabel: 'Read less',
    },
  },
  ...loginLocales,
  ...dashboardLocales,
  ...settingsLocales,
  ...maintenanceModeLocales,
  ...paymentsLocales,
  ...configurationLocales,
  ...peopleLocales,
  ...surveysLocales,
  ...departmentsLocales,
  ...aiPlaygroundLocales,
  ...trainingHardSkillsLocales,
  ...trainingSoftSkillsLocales,
  ...profileLocales,
  ...creditsLocales,
  ...departmentLocales,
  ...conversationLocales,
  ...quizLocales,
  ...videoLocales,
  ...documentLocales,
  ...assessmentsLocales,
  ...reportsLocales,
  ...invitationLocales,
  ...coreLocales,
  ...billingLocales,
};
